(function () {
  function buildStarsMarkup(count) {
    const safeCount = Math.max(0, Math.min(5, parseInt(count || 5, 10)));
    let markup = '';

    for (let index = 0; index < 5; index += 1) {
      const opacity = index < safeCount ? 1 : 0.22;
      markup += '<span class="star" aria-hidden="true" style="opacity:' + opacity + '"><svg viewBox="0 0 24 24"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26Z"></path></svg></span>';
    }

    return markup;
  }

  function normalizeText(element) {
    if (!element) return '';
    return (element.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function extractBodyText(review) {
    const body = review.querySelector('.jdgm-rev__body');
    if (!body) return '';

    const paragraphs = Array.from(body.querySelectorAll('p'));
    const paragraphText = paragraphs
      .map(function (paragraph) {
        return normalizeText(paragraph);
      })
      .filter(Boolean)
      .join(' ');

    if (paragraphText) {
      return paragraphText;
    }

    const clone = body.cloneNode(true);
    clone.querySelectorAll('a, button, .jdgm-rev__read-more').forEach(function (node) {
      node.remove();
    });

    return normalizeText(clone);
  }

  function isUsefulReview(review, bodyText, titleText) {
    const productTitle = (review.getAttribute('data-product-title') || '').trim();
    const normalizedBody = (bodyText || '').trim().toLowerCase();
    const normalizedTitle = (titleText || '').trim().toLowerCase();
    const normalizedProductTitle = productTitle.toLowerCase();

    if (!normalizedBody) return false;
    if (normalizedBody === 'read more') return false;
    if (normalizedBody.length < 12) return false;
    if (normalizedBody === normalizedTitle) return false;
    if (normalizedProductTitle && normalizedBody === normalizedProductTitle) return false;

    return true;
  }

  function extractReviewData(review) {
    const author = normalizeText(review.querySelector('.jdgm-rev__author, .jdgm-author'));
    const title = normalizeText(review.querySelector('.jdgm-rev__title'));
    const body = extractBodyText(review);
    const date = normalizeText(review.querySelector('.jdgm-rev__timestamp, .jdgm-rev__publish-date, time'));
    const ratingWrapper = review.querySelector('.jdgm-rev__rating, .jdgm-row-stars');
    const ratingCount = ratingWrapper ? ratingWrapper.querySelectorAll('.jdgm-star, .jdgm--on').length || 5 : 5;

    return {
      author: author,
      title: title,
      body: body,
      date: date,
      ratingCount: ratingCount
    };
  }

  function applyReviewData(card, reviewData) {
    const authorElement = card.querySelector('[data-review-author]');
    const avatarElement = card.querySelector('[data-review-avatar]');
    const dateElement = card.querySelector('[data-review-date]');
    const titleElement = card.querySelector('[data-review-title]');
    const bodyElement = card.querySelector('[data-review-body]');
    const starsElement = card.querySelector('[data-review-stars]');

    if (reviewData.author && authorElement) {
      authorElement.textContent = reviewData.author;
    }

    if (reviewData.author && avatarElement) {
      avatarElement.textContent = reviewData.author.charAt(0);
    }

    if (reviewData.date && dateElement) {
      dateElement.textContent = reviewData.date;
    }

    if (reviewData.title && titleElement) {
      titleElement.textContent = reviewData.title;
    }

    if (reviewData.body && bodyElement) {
      bodyElement.textContent = reviewData.body;
    }

    if (starsElement) {
      starsElement.innerHTML = buildStarsMarkup(reviewData.ratingCount);
    }

    card.classList.remove('is-empty');
    card.classList.remove('is-unresolved');
  }

  function initializeSection(section) {
    if (!section || section.dataset.reviewsInitialized === 'true') return;

    const track = section.querySelector('[data-reviews-track]');
    const cards = Array.from(section.querySelectorAll('[data-review-card]'));
    const sourceCards = cards.slice();
    const prevButton = section.querySelector('[data-reviews-prev]');
    const nextButton = section.querySelector('[data-reviews-next]');
    const emptyState = section.querySelector('[data-reviews-empty]');
    const autoplayEnabled = section.dataset.autoplayEnabled === 'true';
    const autoplayDelay = parseInt(section.dataset.autoplayDelay || '4000', 10);

    if (!track || !cards.length) {
      section.dataset.reviewsInitialized = 'true';
      return;
    }

    let autoplayTimer = null;
    let observer = null;

    function getUsefulReviews(card) {
      const source = card.querySelector('[data-review-source]');
      if (!source) return [];

      const reviews = Array.from(source.querySelectorAll('.jdgm-rev, .jdgm-carousel-item, .jdgm-rev-widg__review'));
      return reviews.filter(function (candidate) {
        const titleText = normalizeText(candidate.querySelector('.jdgm-rev__title'));
        const bodyText = extractBodyText(candidate);
        return isUsefulReview(candidate, bodyText, titleText);
      });
    }

    function hydrateReviews() {
      let resolvedCount = 0;

      sourceCards.forEach(function (card) {
        const usefulReviews = getUsefulReviews(card);
        const requestedIndex = Math.max(0, (parseInt(card.dataset.reviewNumber || '1', 10) || 1) - 1);

        if (!usefulReviews.length) {
          card.classList.add('is-empty');
          return;
        }

        applyReviewData(card, extractReviewData(usefulReviews[Math.min(requestedIndex, usefulReviews.length - 1)]));
        resolvedCount += 1;
      });

      section.classList.toggle('is-empty-state', resolvedCount === 0);

      if (emptyState) {
        emptyState.hidden = resolvedCount > 0;
      }

      return resolvedCount;
    }

    function finalizeUnresolvedCards() {
      sourceCards.forEach(function (card) {
        if (card.classList.contains('is-empty')) {
          card.classList.add('is-unresolved');
        }
      });
    }

    function initializeJudgeMe() {
      if (window.jdgm && typeof window.jdgm.onInstalled === 'function') {
        window.jdgm.onInstalled();
        return true;
      }

      return false;
    }

    function watchReviewSources() {
      if (!window.MutationObserver) return;
      if (observer) observer.disconnect();

      observer = new MutationObserver(function () {
        const resolvedCount = hydrateReviews();
        if (resolvedCount > 0 && observer) {
          observer.disconnect();
        }
      });

      sourceCards.forEach(function (card) {
        const source = card.querySelector('[data-review-source]');
        if (!source) return;
        observer.observe(source, { childList: true, subtree: true });
      });
    }

    function getStep() {
      const firstCard = cards[0];
      if (!firstCard) return track.clientWidth;
      const gap = parseFloat(window.getComputedStyle(track).gap || 0);
      return firstCard.getBoundingClientRect().width + gap;
    }

    function next() {
      const maxScrollLeft = track.scrollWidth - track.clientWidth;
      const nextPosition = track.scrollLeft + getStep();

      if (nextPosition >= maxScrollLeft - 4) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }

      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    }

    function prev() {
      const maxScrollLeft = track.scrollWidth - track.clientWidth;

      if (track.scrollLeft <= 4) {
        track.scrollTo({ left: maxScrollLeft, behavior: 'smooth' });
        return;
      }

      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    }

    function stopAutoplay() {
      if (!autoplayTimer) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function startAutoplay() {
      if (!autoplayEnabled || sourceCards.length < 2) return;
      stopAutoplay();
      autoplayTimer = window.setInterval(next, autoplayDelay);
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    track.addEventListener('mouseenter', stopAutoplay);
    track.addEventListener('mouseleave', startAutoplay);
    track.addEventListener('focusin', stopAutoplay);
    track.addEventListener('focusout', startAutoplay);

    const shopDomain = section.dataset.shopDomain;
    const fetchedProducts = {};

    // Fallback when the judgeme.widget metafield is empty: load review HTML from Judge.me directly
    function fetchProductReviews(productId) {
      if (!productId || !shopDomain || !window.fetch) return Promise.resolve('');
      if (!fetchedProducts[productId]) {
        const params = new URLSearchParams({
          url: shopDomain,
          shop_domain: shopDomain,
          platform: 'shopify',
          page: '1',
          per_page: '10',
          product_id: productId
        });
        fetchedProducts[productId] = fetch('https://judge.me/reviews/reviews_for_widget?' + params.toString())
          .then(function (response) { return response.ok ? response.json() : {}; })
          .then(function (data) { return (data && data.html) || ''; })
          .catch(function () { return ''; });
      }
      return fetchedProducts[productId];
    }

    function loadMissingSources() {
      return Promise.all(sourceCards.map(function (card) {
        const source = card.querySelector('[data-review-source]');
        if (!source || getUsefulReviews(card).length) return Promise.resolve();

        return fetchProductReviews(card.dataset.productId).then(function (html) {
          if (html) source.innerHTML = html;
        });
      }));
    }

    let attempts = 0;

    function tryHydrate() {
      initializeJudgeMe();
      const resolvedCount = hydrateReviews();
      attempts += 1;

      if (attempts === 1 && resolvedCount < sourceCards.length) {
        loadMissingSources().then(hydrateReviews);
      }

      const unresolvedCards = sourceCards.filter(function (card) {
        return card.classList.contains('is-empty');
      }).length;

      if (resolvedCount === 0 && attempts === 1) {
        watchReviewSources();
      }

      if (unresolvedCards > 0 && attempts < 10) {
        window.setTimeout(tryHydrate, 500);
        return;
      }

      finalizeUnresolvedCards();
    }

    section.dataset.reviewsInitialized = 'true';
    tryHydrate();
    startAutoplay();
  }

  function initializeHomepageReviews() {
    document.querySelectorAll('[data-homepage-reviews]').forEach(initializeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHomepageReviews);
  } else {
    initializeHomepageReviews();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeSection(event.target.querySelector('[data-homepage-reviews]') || event.target);
  });
})();